import React from 'react'
import classes from './home.module.css'
import { CopyrightOutlined } from '@ant-design/icons'

function Foot() {
    return (
        <div className={classes.footMainH5}>
            <div>
                <CopyrightOutlined /> 2002 - 现在 bnsrj.com copyRight
            </div>
            <div style={{ marginTop: '16px' }}>版权所有：湖北伯纳思网络科技有限公司</div>
            <div style={{ marginTop: '16px' }}>
                <span
                    role="link"
                    tabIndex={0}
                    onClick={() => {
                        window.open('https://beian.miit.gov.cn/')
                    }}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') window.open('https://beian.miit.gov.cn/')
                    }}
                    style={{ cursor: 'pointer', color: '#aaa' }}
                >
                    鄂ICP备18025660号-3
                </span>
            </div>
        </div>
    )
}

export default Foot
